import { registerApplication, start } from 'single-spa';
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from 'single-spa-layout';
import microfrontendLayout from './microfrontend-layout.html';
import { CommonLogger } from './services/logger';

CommonLogger.init();

// Need to export shared Auth0 Plugin and Utils for consumption by child apps
export { Auth0Plugin } from './auth';
export { AUTH_ROLES, ROLES_BY_GROUP } from './auth/utils';
export * from './auth/controllers/users';
export * from './auth/controllers/tenant';

const routes = constructRoutes(microfrontendLayout);
const applications = constructApplications({
  routes,
  loadApp({ name }) {
    return System.import(name);
  },
});
const layoutEngine = constructLayoutEngine({ routes, applications });

applications.forEach(registerApplication);
layoutEngine.activate();
start();
